import { render } from "./YitIcon.vue?vue&type=template&id=7c934c86&scoped=true"
import script from "./YitIcon.vue?vue&type=script&lang=js"
export * from "./YitIcon.vue?vue&type=script&lang=js"

import "./YitIcon.vue?vue&type=style&index=0&id=7c934c86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c934c86"]])

export default __exports__